<div class="driver-call-status" *transloco="let t; prefix: 'accidents.driverCallStatus'">
  @if (callResult) {
    <span class="driver-call-status__call-result">
      {{ callResult }}
    </span>
  }
  @if (driverStatus) {
    <span class="driver-call-status__driver-status">
      {{ driverStatus }}
    </span>
  }
  @if (!callResult && !driverStatus) {
    <span class="driver-call-status__empty">{{ '---' }}</span>
  }
</div>